export class CreateStoreCoordinates {
  latitude: number | null;
  longitude: number | null;

  constructor() {
    this.latitude = null;
    this.longitude = null;
  }
}
